let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("86Mbi")).then(() => parcelRequire('9HIUE'));